import { SetAtom } from "@/types/global";
import axios from "axios";
import { FeatureCollection } from "geojson";
import { MutableRefObject, SetStateAction } from "react";
import { toast } from "react-toastify";

export const fetch_panels = async (
  drawRef: MutableRefObject<MapboxDraw | null>,
  setRoofFeatures: SetAtom<[SetStateAction<FeatureCollection>], void>,
  centerPoint: MutableRefObject<[string, string] | null>
) => {
  console.log(drawRef.current?.getAll());

  const unprocessed_drawing_features = drawRef.current?.getAll();
  console.log(unprocessed_drawing_features);

  console.log(drawRef.current?.getAll());

  const featureCollectionData =
    unprocessed_drawing_features?.features.map((feature) => {
      return feature;
    }) ?? [];

  console.log(featureCollectionData);

  const results = await axios
    .post(
      import.meta.env.PROD
        ? `${process.env.ETAGEN_API}/rooftop/v2/latlong_panel_coordinates/`
        : "http://localhost:8080/rooftop/v2/latlong_panel_coordinates/",
      {
        type: "FeatureCollection",
        features: featureCollectionData,
      },
      {
        headers: {
          'Content-Type': 'application/json;',
          'Access-Control-Allow-Origin': "*"
        }
      }
    )
    .then((res) => {
      return res.data;
    });
  console.log(results);
  setRoofFeatures(results);

  const buildingMetaDataObj = results.metadata.buildingInfo;
  const buildingMetaDataKeys = Object.keys(buildingMetaDataObj);

  buildingMetaDataKeys.forEach((mKey) => {
    drawRef.current?.setFeatureProperty(
      mKey,
      "capacityKwp",
      buildingMetaDataObj[mKey]["capacityKwp"]
    );
    drawRef.current?.setFeatureProperty(
      mKey,
      "panelCount",
      buildingMetaDataObj[mKey]["panelCount"]
    );
  });
  centerPoint.current = results.metadata.centerPoint;

  toast(`Generated ${results.features.length} panels`);
};
